import { useState } from 'react';
import PropTypes from 'prop-types';
import TopBar from './TopBar';

const styles ={
  root: {
    backgroundColor: '#f4f6f8',
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}
function DashboardLayout({ children }: any) {
  const [, setMobileNavOpen] = useState(false);

  return (
    <div style={styles.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <div style={styles.wrapper}>
        <div style={styles.contentContainer}>
          <div style={styles.content}>{children}</div>
        </div>
      </div>
    </div>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.any
};

export default DashboardLayout;
